<template>
  <div>
    <!-- <header-component></header-component> -->
    <el-row class="leapin-candidate-info-page">
      <div class="content">
        <el-row class="top-nav">
          <el-col :span="2">
              <img class="logo" :src="logo" />
          </el-col>
          <el-col :span="22">
            <div class="name">
              WELCOME ONBOARD !<br>
              <!-- {{ $store.state.user.userInfo.first_name }} {{ $store.state.user.userInfo.last_name }}  -->
            </div>
            <div class="introduce">
              Greetings! I'm max，your AI job advisor. Ready to hunt for your dream job or steer your career? 
            </div>
            <div class="introduce">
              Dive in and tell me your story—just a 3-minute chat to get started. Your future awaits! 🌟 
              <img class="nav-icon2" :src="nav2" />
            </div>
          </el-col>
          <img class="nav-icon1" :src="nav1" />
          <img class="nav-icon3" :src="nav3" />
        </el-row>

        <!-- 信息填写 -->
        <div class="info-box">
          <info-form :editType="0" @routerChange="routerChange" @scrollToTop="scrollToTop"></info-form>
        </div>

      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {
    //HeaderComponent: () => import('@/components/header/Header.vue')
    InfoForm: () => import('./components/infoForm.vue')
  },
  name: 'CandidateInfo',
  data() {
    return {
      nav1: require('@/assets/svgs/candi-nav-1.svg'),
      nav2: require('@/assets/svgs/candi-nav-2.svg'),
      nav3: require('@/assets/svgs/candi-nav-3.svg'),
      chioce: require('@/assets/svgs/choice.svg'),
      circle: require('@/assets/svgs/circle.svg'),
      logo: require('../../assets/images/logo.png'),

    }
  },
  mounted () {

  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    routerChange (type) {
      this.$router.push({ path: '/CandidateReport' })
    }
  }
}
</script>
<style lang="scss" scoped>
.leapin-candidate-info-page {
  background: url('../../assets/svgs/identity-back.svg') no-repeat center center;
  background-size: cover;
  .content {
    border-radius: 32px;
    margin: 40px 120px;
    .top-nav {
      padding: 36px 32px;
      border-radius: 32px;
      background: #6E62E5;
      font-family: poppins;
      position: relative;
      .logo {
        width: 64px;
        height: 64px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 64px;
        margin: 0 auto;
        img {
          width: 38px;
          height: 38px;
        }
      }
      .name {
        color: #FFF;
        font-family: Poppins;
        font-size: 30px;
        font-weight: 600;
        letter-spacing: 1px;
      }
      .introduce {
        margin-top: 8px;
        color: rgba(255, 255, 255, 0.60);
        font-family: 'Helvetica';
        font-size: 14px;
        font-weight: 300;
        letter-spacing: 2px;
        position: relative;
        width: fit-content;
      }
      .nav-icon1 {
        position: absolute;
        left: 8%;
        top: 10px;
        z-index: 9;
      }
      .nav-icon2 {
        position: absolute;
        bottom: 10px;
        right: -20%;
      }
      .nav-icon3 {
        position: absolute;
        bottom: 0px;
        right: 2%;
      }
    }
    .info-box {
      // height: calc(100vh - 340px);
      // overflow-x: hidden;
      // overflow-y: scroll;
    }
  }
  .el-step {
    background: transparent !important;
  }
}
</style>
